import type {CurriedSelector, Reducer} from '@/redux/types';
import type {
  Data,
  KeywordDataState,
  Status,
} from '@/redux/v1/keywordData/models';
import type {ActionHandlers} from '@travel-frontend/state-handling-sdk';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {curry} from 'lodash';

import {FETCH_KEYWORD_DATA} from '@/redux/v1/keywordData/models';
import {keywordDataState} from '@/redux/v1/v1State';

const initialState: KeywordDataState = {
  status: {},
  data: {},
  errors: {},
};

const actionHandlers: ActionHandlers<KeywordDataState> = {
  [PENDING(FETCH_KEYWORD_DATA)]: (state: KeywordDataState, action) => ({
    ...state,
    status: {
      ...state.status,
      [action.meta.keywordId]: 'loading',
    },
  }),
  [SUCCESS(FETCH_KEYWORD_DATA)]: (state: KeywordDataState, action) => ({
    ...state,
    status: {
      ...state.status,
      [action.meta.keywordId]: 'successful',
    },
    data: {
      ...state.data,
      [action.meta.keywordId]: action.payload,
    },
  }),
  [ERROR(FETCH_KEYWORD_DATA)]: (state: KeywordDataState, action) => ({
    ...state,
    status: {
      ...state.status,
      [action.meta.keywordId]: 'failed',
    },
    errors: {
      ...state.errors,
      [action.meta.keywordId]: action.error,
    },
  }),
};

export const reducer: Reducer<KeywordDataState> =
  createReducerUsingActionHandlers<any>(initialState, actionHandlers);

export const selectStatusById: CurriedSelector<string, Status> = curry(
  // @ts-expect-error ...
  (keywordId, state) => keywordDataState(state).status[keywordId] || 'idle'
);

export const selectDataById: CurriedSelector<string, null | undefined | Data> =
  curry(
    // @ts-expect-error ...
    (keywordId, state) => keywordDataState(state).data[keywordId]
  );

// @ts-expect-error ...
export const selectErrorById: CurriedSelector<
  string,
  null | undefined | Error
> = curry(
  // @ts-expect-error ...
  (keywordId, state) => keywordDataState(state).errors[keywordId]
);
